// Header.tsx
import React, { useState } from 'react';
import { IoArrowBack, IoNotifications, IoShieldCheckmark } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import { universities } from '@/resources/universities';
import { useUniversityData } from '@/services/universityService';
import NotificationModal from '@/components/NotificationModal';

interface HeaderProps {
  user: any;
  setUser: (user: any | null) => void;
}

const ArrowBackIcon = IoArrowBack as React.ComponentType<{ className?: string }>;
const NotificationsIcon = IoNotifications as React.ComponentType<{ className?: string }>;
const AdminIcon = IoShieldCheckmark as React.ComponentType<{ className?: string }>;

const Header: React.FC<HeaderProps> = ({ user, setUser }) => {
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const university = location.pathname.split('/')[2] || null;
  const universityId = university ? parseInt(university) : null;
  const showBack = !!university;
  
  // Fetch university data when on a university page
  const { data: universityData } = useUniversityData(universityId || 0);
  
  const [randomDays] = useState(Math.floor(Math.random() * 30) + 1);

  return (
    <header className="sticky top-0 z-40 w-full bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between px-8 py-4 shadow-sm">
      <div className="flex items-center space-x-4">
        {showBack && (
          <>
            <button onClick={() => navigate(-1)} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors dark:text-gray-200">
              <ArrowBackIcon className="text-xl" />
            </button>
            <div className="w-[500px] hidden lg:block">
              <div className="flex items-baseline space-x-5 mb-1">
                <span className="text-lg font-medium dark:text-gray-100">
                  {universityData?.university_name || 'Loading...'}
                </span>
                <div className="flex items-center space-x-2" data-tour="text-notifications">
                  <span className="text-sm font-medium text-gray-400 dark:text-gray-400">
                    Due in {universityData?.days_remaining || 0} Days
                  </span>
                  <button 
                    className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                    onClick={() => setShowNotificationModal(true)}
                    title="Notification settings"
                  >
                    <NotificationsIcon className="text-sm text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" />
                  </button>
                </div>
              </div>
              <div className="flex h-2 space-x-1 max-w-[260px]">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div
                    key={i}
                    className={`flex-1 rounded ${
                      i < 3 ? 'bg-orange-500' : 'bg-gray-200 dark:bg-gray-700'
                    }`}
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </div>


      <div className="flex items-center space-x-3">
        {user ? (
          <>
            {user.role === 'admin' && (
              <button 
                className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors dark:text-gray-200"
                title="Admin Panel"
                onClick={() => navigate('/admin')}
              >
                <AdminIcon className="text-xl" />
              </button>
            )}
          </>
        ) : (
          <button
            onClick={() => {}}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 dark:bg-purple-700 dark:hover:bg-purple-600 transition-colors"
          >
            Sign In
          </button>
        )}
      </div>
      <NotificationModal 
        isOpen={showNotificationModal}
        onClose={() => setShowNotificationModal(false)}
        user={user}
        schoolName={universityData?.university_name}
      />
    </header>
  );
};

export default Header;
